import {Status} from "../shared/models/status";

export class Changes {
  public id = "";
  public text ="";
  public documentId = "";
  public computer = "";
  public user = "";
  public date = "";
  public info = "";
  public path = "";
  public project = "";
  public status = "";
  public docStatus = new Status();
  public isNew = false;
}
